<template>
  <div>
    <subscribe-telegram-dialog
      v-if="!fetchIsLoading && subscribeTelegramIsShown && telegramSubscribeDialogIsShown"
      :is-shown="telegramSubscribeDialogIsShown"
      @close="closeTelegramDialog()"
    />
    <add-messenger-dialog
      v-if="addMessengerDialogIsShown"
      :is-shown="addMessengerDialogIsAvailable"
      @close-dialog="closeMessengerDialog()"
    />
  </div>
</template>

<script>
  import { mapState } from 'pinia'
  import Cookies from 'js-cookie'
  import routeNames from '@/types/route-names'
  import guardSections from '@/types/guard-sections'
  import SubscribeTelegramDialog from '@/views/Dashboard/InformationCards/SubscribeTelegramDialog.vue'
  import AddMessengerDialog from '@/components/AddMessengerDialog.vue'
  import { useSettingsStore } from '@/store/settings/settings'
  import { usePersonalStore } from '@/store/personal/personal'

  const TELEGRAM_SUBSCRIBE_DIALOG_IS_SHOWN = 'telegram_subscribe_dialog_is_shown'
  const ADD_MESSENGER_DIALOG_IS_SHOWN = 'add_messenger_dialog_is_shown'

  export default {
    name: 'LayoutModals',
    components: { AddMessengerDialog, SubscribeTelegramDialog },
    data() {
      return {
        addMessengerDialogIsShown: false,
        telegramSubscribeDialogIsShown: !Number(Cookies.get(TELEGRAM_SUBSCRIBE_DIALOG_IS_SHOWN))
      }
    },
    computed: {
      ...mapState(useSettingsStore, ['adNetwork']),
      ...mapState(usePersonalStore, ['subscribeTelegram', 'fetchIsLoading', 'userMessengers']),
      adNetworkHasSectionProfile() {
        return this.adNetwork.guardSections.some(({ name }) => name === guardSections.PROFILE)
      },
      subscribeTelegramIsShown() {
        return (
          !this.subscribeTelegram &&
          this.$route.name === routeNames.DASHBOARD &&
          this.adNetworkHasSectionProfile &&
          this.adNetwork.telegramBotName &&
          !this.addMessengerDialogIsShown
        )
      },
      addMessengerDialogIsAvailable() {
        return this.$route.name === routeNames.CAMPAIGN_STATISTICS
      }
    },
    async created() {
      this.addMessengerDialogIsShown =
        !Number(Cookies.get(ADD_MESSENGER_DIALOG_IS_SHOWN)) && this.userMessengers?.length === 0
    },
    methods: {
      closeTelegramDialog() {
        Cookies.set(TELEGRAM_SUBSCRIBE_DIALOG_IS_SHOWN, 1, { expires: 30 })
        this.telegramSubscribeDialogIsShown = false
      },
      closeMessengerDialog() {
        Cookies.set(ADD_MESSENGER_DIALOG_IS_SHOWN, 1, { expires: 30 })
        this.addMessengerDialogIsShown = false
      }
    }
  }
</script>
